export default __webpack_public_path__ + "static/media/roboto-v20-latin-italic.5b35ce29.svg";